module.exports = __webpack_public_path__ + "static/media/transportschemaen@2x.ec275405.png";